export const SORT_BY_PARAM_KEY = "sortBy";
export const SORT_ORDER_PARAM_KEY = "sortOrder";
export const PAGE_PARAM_KEY = "page";
export const PER_PAGE_PARAM_KEY = "perPage";
